export default "__VITE_ASSET__05b970fc__"